document.addEventListener('DOMContentLoaded', function () {
    const swiperWrapperBlog = document.querySelector('.wrapper-swiper__blog');
    const swiperBlog = swiperWrapperBlog.querySelector('.swiper');
    const prevButton = swiperBlog.querySelector(".swiper-navigation-custom.prev");
    const nextButton = swiperBlog.querySelector(".swiper-navigation-custom.next");
    const pagination = swiperBlog.querySelector(".swiper-pagination");
    const autoplaySpeed = parseInt(swiperWrapperBlog.getAttribute("data-autoplay-speed")) * 1000;



    let navigationCustom = null;
    let {
        arrows,
        bullets,
        viewDesktopLarge,
        viewDesktop,
        viewTablet,
        viewMobile
    } = swiperWrapperBlog.dataset;
    
    console.log(bullets)
    viewDesktopLarge == 1 ? (viewDesktopLarge = "auto") : viewDesktopLarge;
    viewDesktop == 1 ? (viewDesktop = "auto") : viewDesktop;
    viewTablet == 1 ? (viewTablet = "auto") : viewTablet;

    if (arrows) {
        navigationCustom = {
            nextEl: nextButton,
            prevEl: prevButton,
        }
    }

    const breakpointsCustom = {
        580: {
            slidesPerView: viewTablet,
            spaceBetween: 20
        },
        1200: {
            slidesPerView: viewDesktop,
            spaceBetween: 28,
        },
        1380: {
            slidesPerView: viewDesktopLarge,
            spaceBetween: 28,
        },
    };



    swiperElement = new Swiper('.swiper-blog', {
        slidesPerView: viewMobile,
        spaceBetween: 30,
        allowMouseEvents: false,
        breakpoints: breakpointsCustom,
        navigation: navigationCustom,
        pagination: {
            el: bullets ? '.swiper-pagination-blog' : null,
            clickable: bullets ? true : false
        }
    });
});